var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register-page box"},[_c('div',{staticClass:"mb-20"},[_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('a-icon',{attrs:{"type":"arrow-left"}}),_vm._v(" Voltar ")],1)]),_c('div',{staticClass:"logo-conectar mb-20"},[_c('center',[_c('img',{attrs:{"src":require("../../assets/images/conectar.png"),"alt":"logo","width":"260"}})])],1),_c('div',{staticClass:"mb-20"},[_c('a-steps',{attrs:{"type":"navigation","size":"small"},model:{value:(_vm.currentStep),callback:function ($$v) {_vm.currentStep=$$v},expression:"currentStep"}},[_c('a-step',{attrs:{"status":"process","title":"Perfil"}}),_c('a-step',{attrs:{"status":_vm.allowNextStep() ? 'wait' : 'process',"disabled":_vm.allowNextStep(),"title":"Dados"}})],1)],1),_c('a-form',{attrs:{"form":_vm.form}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentStep == 0),expression:"currentStep == 0"}]},[_c('div',{staticClass:"text mb-30"},[_vm._v(" Informe abaixo qual é o seu perfil: ")]),_c('div',{staticClass:"mb-30"},[_c('div',[_c('a-form-item',[_c('a-radio-group',{staticClass:"register-type",attrs:{"options":_vm.resgisterTypes},model:{value:(_vm.selectedRegisterType),callback:function ($$v) {_vm.selectedRegisterType=$$v},expression:"selectedRegisterType"}})],1)],1),_c('div',{staticClass:"investor-profile"},[(_vm.selectedRegisterType == 'Investidor')?_c('InvestorProfile',{attrs:{"form":_vm.form}}):_vm._e()],1)]),_c('div',[_c('a-button',{staticClass:"mt-20 mb-40",staticStyle:{"width":"100%"},attrs:{"type":"primary","shape":"round","size":"large","disabled":_vm.allowNextStep(),"ghost":""},on:{"click":function($event){_vm.currentStep = 1}}},[_vm._v(" Cadastrar Dados "),_c('a-icon',{attrs:{"type":"arrow-right"}})],1)],1)]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentStep == 1),expression:"currentStep == 1"}]},[_c('a-form-item',[_c('a-radio-group',{staticClass:"register-type",attrs:{"options":_vm.personTypes},model:{value:(_vm.selectedPersonType),callback:function ($$v) {_vm.selectedPersonType=$$v},expression:"selectedPersonType"}})],1),(
                    _vm.selectedPersonType == 'Pessoa Física' &&
                        _vm.selectedRegisterType
                )?_c('RegisterPerson',{attrs:{"preRegisterData":{
                    user_profile: _vm.selectedRegisterType,
                    business_type_of_interest: _vm.form.getFieldValue(
                        'business_type_of_interest'
                    )
                        ? JSON.stringify(
                              _vm.form.getFieldValue(
                                  'business_type_of_interest'
                              )
                          )
                        : '[]',
                    area_size_of_interest: _vm.form.getFieldValue(
                        'area_size_of_interest'
                    )
                        ? JSON.stringify(
                              _vm.form.getFieldValue('area_size_of_interest')
                          )
                        : '[]',
                    state_of_interest: _vm.form.getFieldValue(
                        'state_of_interest'
                    )
                        ? JSON.stringify(
                              _vm.form.getFieldValue('state_of_interest')
                          )
                        : '[]',
                    population_of_interest: _vm.form.getFieldValue(
                        'population_of_interest'
                    )
                        ? JSON.stringify(
                              _vm.form.getFieldValue('population_of_interest')
                          )
                        : '[]',
                    region_of_interest: '[]',
                }}}):_vm._e(),(
                    _vm.selectedPersonType == 'Pessoa Jurídica' &&
                        _vm.selectedRegisterType
                )?_c('RegisterCompany',{attrs:{"preRegisterData":{
                    user_profile: _vm.selectedRegisterType,
                    business_type_of_interest: _vm.form.getFieldValue(
                        'business_type_of_interest'
                    )
                        ? JSON.stringify(
                              _vm.form.getFieldValue(
                                  'business_type_of_interest'
                              )
                          )
                        : '[]',
                    area_size_of_interest: _vm.form.getFieldValue(
                        'area_size_of_interest'
                    )
                        ? JSON.stringify(
                              _vm.form.getFieldValue('area_size_of_interest')
                          )
                        : '[]',
                    state_of_interest: _vm.form.getFieldValue(
                        'state_of_interest'
                    )
                        ? JSON.stringify(
                              _vm.form.getFieldValue('state_of_interest')
                          )
                        : '[]',
                    population_of_interest: _vm.form.getFieldValue(
                        'population_of_interest'
                    )
                        ? JSON.stringify(
                              _vm.form.getFieldValue('population_of_interest')
                          )
                        : '[]',
                    region_of_interest: '[]',
                }}}):_vm._e()],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }